import React from 'react';

import LegacyShipments from './LegacyShipments';
import NewShipments from './NewShipments';

export type ControlTowerView = 'list' | 'table';

const VALID_VIEWS: ControlTowerView[] = ['list', 'table'];
const envView = process.env.REACT_APP_CONTROL_TOWER_VIEW as ControlTowerView;
const CONTROL_TOWER_VIEW: ControlTowerView = VALID_VIEWS.includes(envView)
  ? envView
  : 'table';

const CONTROL_TOWER_VIEWS: Record<ControlTowerView, React.FC> = {
  list: LegacyShipments,
  table: NewShipments,
};

const Shipments: React.FC = () => {
  const SelectedView = CONTROL_TOWER_VIEWS[CONTROL_TOWER_VIEW];
  return <SelectedView />;
};

export default Shipments;
